import React from 'react';
import axios from 'axios';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Link,
  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,
  chakra,
  Container,
  VStack,
  VisuallyHidden,
  List,
  ListItem,
} from '@chakra-ui/react';

export default function Profile_detail() {
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    axios
      .get('https://glb-api.onrender.com/student/basicdetails', {withCredentials : true})
      .then((res) => {
        console.log("stu data",res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
        // setError('Failed to fetch the details right now.')
      });
  }, []);

  return (
    <>
      <div>
        <Box>
          <Card  variant={'unstyled'} boxShadow="none" >
            <CardBody>
              <Box bg="white" shadow="md" borderRadius="md" p="6" width="100%">
                <Flex alignItems="center" justifyContent="space-between">
                  <Heading as="h1" size="2xl">
                    Basic Details
                  </Heading>
                  <Button
                    leftIcon={<EditIcon />}
                    marginTop={'4px'}
                    colorScheme="blue"
                    variant="outline"
                    size={'lg'}
                    display={{ base: 'none', md: 'inline-flex' }}
                    fontSize={{ base: 'md', md: '2xl' }}
                    href={'#'}
                  >
                    Edit info
                  </Button>
                </Flex>
              </Box>

              <Box className="mt-10">
                <Center>
                  <Box width={'100%'}>
                    <Card variant={'elevated'}>
                      <CardHeader>
                        <Flex>
                          <Avatar src="https://ih1.redbubble.net/image.4909470396.2618/st,small,507x507-pad,600x600,f8f8f8.jpg" size={'xl'} />
                          <Box ml="3">
                            <Text fontWeight="bold" fontSize={{ base: 'xl', md: '2xl' }}>
                              {data.firstName + ' ' + data.lastName}
                              <Badge ml="1" size={'lg'} colorScheme="green">
                                New
                              </Badge>
                            </Text>
                            <Text fontSize={{ base: 'md', md: 'lg' }}>UI Engineer</Text>
                          </Box>
                        </Flex>
                        <Divider marginTop={'10px'} />
                      </CardHeader>

                      <CardBody>
                        <SimpleGrid columns={2} spacingX="0px">
                        {data.firstName && (
                          <>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>NAME:</Text>
                            </Box>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>
                                {data.firstName + ' ' + data.middleName + ' ' + data.lastName}
                              </Text>
                            </Box>
                          </>
                        )}
                          {data.dob && (
                          <>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>DATE OF BIRTH:</Text>
                            </Box>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>{data.dob}</Text>
                            </Box>
                          </>
                        )}
                          <Box height="50px">
                            <Text fontSize={{ base: 'md', md: '2xl' }}>GENDER:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: 'md', md: '2xl' }}>Male</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: 'md', md: '2xl' }}>E-MAIL:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: 'md', md: '2xl' }}>Signupandogin@gmail.com</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: 'md', md: '2xl' }}>Contact Details:</Text>
                          </Box>
                          <Box height="50px">
                            <Text fontSize={{ base: 'md', md: '2xl' }}>+91-3243276186</Text>
                          </Box>
                          {data.contactDetails && data.contactDetails.permAddress && (
                          <>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>PERMANENT ADDRESS:</Text>
                            </Box>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>{data.contactDetails.permAddress}</Text>
                            </Box>
                          </>
                        )}
                          {data.contactDetails && data.contactDetails.curAddress && (
                          <>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>CURRENT ADDRESS:</Text>
                            </Box>
                            <Box height="50px">
                              <Text fontSize={{ base: 'md', md: '2xl' }}>{data.contactDetails.curAddress}</Text>
                            </Box>
                          </>
                        )}
                        </SimpleGrid>
                      </CardBody>
                    </Card>
                  </Box>
                </Center>
              </Box>
            </CardBody>
          </Card>
        </Box>
      </div>
    </>
  );
}
